/**
 * this module is used to overwrite all project dependent client config options handled by frontend-controller/lib/appConfig.js
 */
module.exports = {
	useFecClient: true,
	// bindTouchableEvents: true, // TODO: check if this is necessary
	store: {
		name: 'IBT-Store',
		cookie: {
			policy: {
				acceptTrackingDefault: null,
				acceptTrackingByDefault: false
			}
		}
	},
	i18next: {
		ns: ['common','error','button'],
		lngs: ['de-at','en-gb']
	},
	debug: {
		fallbackConsole: false
	},
	useIDSelector: true
};